import { useMemo } from 'react';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import type { CreativeText } from '../types';
import { format } from 'date-fns';
import { CellContainer, CellTypography } from '../components/CreativeTextsGrid.styles';
import { Tooltip } from '@mui/material';

const columnsAdditionalOptions = {
  disableColumnFilter: true,
  disableColumnMenu: true,
};

export const useCreativeTextsColumns = (): GridColDef[] => {
  return useMemo(
    () => [
      {
        field: 'text',
        headerName: 'Text',
        width: 700,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).text}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'language',
        headerName: 'Language',
        width: 120,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).language.toUpperCase()}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'app',
        headerName: 'App',
        width: 160,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).app ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'default_flows',
        headerName: 'Default for flows',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => {
          const flows = (params.row as CreativeText).default_flows?.map(f => f.name)?.join(', ') ?? '-';
          return (
            <CellContainer>
              <Tooltip title={flows}>
                <CellTypography variant={'body2'}>
                  {flows}
                </CellTypography>
              </Tooltip>
            </CellContainer>
          );
        },
        ...columnsAdditionalOptions,
      },
      {
        field: 'created_at',
        headerName: 'Created',
        width: 120,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {format(
                new Date((params.row as CreativeText).created_at),
                'yyyy-MM-dd',
              )}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
    ],
    [],
  );
};
